import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const TimePicker = ({ formik, fieldName }) => {
    return (
        <div className="date-picker-container">
            <DatePicker
                selected={formik.values[fieldName]}
                onChange={(time) => formik.setFieldValue(fieldName, time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={1}
                timeFormat="h:mm aa" // Display time in 12-hour format with AM/PM
                dateFormat="h:mm aa"
                placeholderText="Select Schedule Time"
                className="date-picker-input"
            />
            <div className="calendar-icon">
                <i className="bx bx-time-five"></i>
            </div>
        </div>
    );
};

export default TimePicker;
